import Introduction from './Introduction'
import About from './About'
import WhatDesignSystem from './WhatDesignSystem'
import Task from './Task'
import Process from './Process'
import QA from './QA'
import ProjectFrom from './ProjectFlow'
import Contact from './Contact'
import styles from './DesignSystem.module.scss'
import Popup from 'components/common/PopupCTADesignSystem/PopupCTADesignSystem'

const DesignSystem: React.FC = () => {
  return (
    <article className={styles.body}>
      <Introduction />
      <About />
      <WhatDesignSystem />
      <Task />
      {/* <Process /> */}
      <QA />
      <ProjectFrom />
      <Contact />
      <article>
        <Popup />
      </article>
    </article>
  )
}

export default DesignSystem
